var _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnassignedAssetAssignMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.321045 16.8395C0.321045 7.5393 7.86035 0 17.1606 0C26.4608 0 34.0001 7.5393 34.0001 16.8395C34.0001 26.1397 26.4608 33.679 17.1606 33.679C7.86035 33.679 0.321045 26.1397 0.321045 16.8395Z",
    fill: "#EE9C23",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1545 29.2827L16.5282 28.7796C13.3883 26.2571 11.0088 23.891 9.43181 21.679M17.1545 29.2827L9.43181 21.679M17.1545 29.2827L17.7808 28.7796C20.9207 26.2571 23.3011 23.8912 24.8801 21.6795C26.4647 19.46 27.3244 17.248 27.3244 15.0618C27.3244 12.1455 26.3137 9.69704 24.2732 7.80286C22.2683 5.94172 19.8796 5 17.1545 5C14.4278 5 12.0393 5.94162 10.0371 7.80344C7.9999 9.69777 6.99109 12.146 6.99109 15.0618C6.99109 17.2476 7.84943 19.4594 9.43181 21.679M17.1545 29.2827L10.2461 21.0985L9.43181 21.679M18.2057 14.9079C18.2057 15.1778 18.1196 15.3874 17.9093 15.5908L17.9093 15.5908C17.6976 15.7955 17.4654 15.891 17.1568 15.891C16.8471 15.891 16.615 15.7954 16.4044 15.5922C16.1964 15.3914 16.1099 15.1827 16.1099 14.9105C16.1099 14.6368 16.1969 14.4254 16.4057 14.2218C16.6141 14.0187 16.8444 13.923 17.1541 13.923C17.4641 13.923 17.6969 14.0188 17.9086 14.2238C18.1195 14.428 18.2057 14.6382 18.2057 14.9079Z",
    fill: "#EE9C23",
    stroke: "white",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14592_27111)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.1601 8.4987C21.1601 5.82723 23.3286 3.65878 26 3.65878C28.6715 3.65878 30.84 5.82723 30.84 8.4987C30.84 11.1702 28.6715 13.3386 26 13.3386C23.3286 13.3386 21.1601 11.1702 21.1601 8.4987Z",
    fill: "white",
    stroke: "#354052",
    strokeWidth: 1.1535
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14592_27111"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "translate(19.5 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnassignedAssetAssignMap);
export default __webpack_public_path__ + "static/media/unassigned-asset-assign-map.0ee6e6d694c7517ed37ebba8099a8ad9.svg";
export { ForwardRef as ReactComponent };